module.exports = __webpack_public_path__ + "img/18.5356c3a3.png";